import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';
import * as Sentry from "@sentry/browser";
import { environment } from 'environments/environment';

Sentry.init({
    dsn: environment.sentry_dns,
    sendDefaultPii: true,
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration()
    ],
    environment: environment.apiUrl.includes("-dv") ? "dev" : (environment.apiUrl.includes("-qa") ? "qa" : "prod"),
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.5,
    replaysOnErrorSampleRate: 0.2,
    beforeSend(event, hint) {
        if (hint?.originalException?.toString().includes('NG0100')) {
          return null;
        }
        return event;
    },    
});

bootstrapApplication(AppComponent, appConfig).catch((err) =>
    console.error(err)
);
